import {gql} from '@apollo/client'

export const USER_LOOKUP = gql`
  query ($email: String!) {
    lookupUser(email: $email) {
      found
      hasCredentials
    }
  }
`

export const VALIDATE_EMAIL = gql`
  query validateEmail($email: String!) {
    validateEmail(email: $email) {
      valid
    }
  }
`
